import React from 'react';
import AdminLayout from '../components/AdminLayout';
import LayoutPanel from '../components/LayoutPanel';
import { useAdminAuth } from '../context/AdminAuthContext';

export default function AdminLayoutPage() {
  const { authHeaders } = useAdminAuth();
  return (
    <AdminLayout>
      <div className="p-4 sm:p-6 max-w-7xl">
        <header className="mb-5">
          <div className="text-[11px] font-bold tracking-[0.2em] text-[#0078D4] uppercase">Site design</div>
          <h1 className="font-display text-2xl sm:text-3xl text-slate-900 mt-0.5">Layout</h1>
          <p className="text-sm text-slate-500 mt-1">
            Control alignment, max-width and vertical padding for every headline and page title. Different settings can be applied to desktop and mobile.
          </p>
        </header>
        <LayoutPanel authHeaders={authHeaders} />
      </div>
    </AdminLayout>
  );
}
